import React from "react";
import ReactDOM from "react-dom";
interface ConfirmationProps {
  onClose: () => void;
  onConfirm: () => void;
  action:string;
}
const ConfirmationModal: React.FC<ConfirmationProps> = ({
  onClose,
  onConfirm,
  action
}) => {
  console.log(action);
  
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-30">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden sm:w-1/3 md:w-1/3 w-10/12">
        <div className="p-4">
          <div className="flex items-center justify-center">
            <div className="ml-4">
                <h3 className="text-lg font-medium text-gray-900 text-center">
                  {action ==='delete' || action ==='deleteError' ? 'Delete Tag Confirmation' : action ==='deleteSector' || action ==='deleteSectorError' ? 'Delete Sector Confirmation' : action ==='approve' ? 'Approve Tag?': action ==='add' ? 'Add New Tag':action ==='EditError' ?'Edit Tag Confirmation' :action ==='EditSectorError' ? 'Edit Sector Confirmation' : action === 'addSector' ? 'Add New Sector' :  action === 'editSector' ? 'Edit Sector': 'Edit Tag'}
                </h3>
                <>
                      <p className="text-base text-gray-500 text-center mt-2">
                      {action ==='delete' ? 'Are you sure you want to permanently delete this Tag.' :action ==='approve' ? 'Are you sure you want to approve this tag?':
                      action ==='deleteError' ? 'This tag is already approved and associated with existing posts. Are you sure you want to delete it?':
                      action ==='edit' ? 'Are you sure you want to edit this tag? This action will update the tag details.':
                      action ==='deleteSector' ? 'Are you sure you want to permanently delete this Sector.':
                      action ==='deleteSectorError' ? 'This sector cannot be deleted as it is currently assigned to one or more posts. Please reassign or remove it from the associated posts before deleting.':
                      action ==='EditSectorError' ? 'This sector cannot be updated as it is currently assigned to one or more posts. Please reassign or remove it from the associated posts before updating.' :
                     action ==='EditError' ? 'This tag is already approved and associated with existing posts. Are you sure you want to edit it?': userInfo.roles !== 'CHIEF_EDITOR' ? 'Are you sure you want to add this tag? This will be directly sent to the Chief Editor for approval.' : action ==='addSector' ? 'Are you sure you want to add this sector? This action will update the sector list.' : action === 'editSector' ? 'Are you sure you want to edit this sector? This action will update the sector details.': 'Are you sure you want to add this tag? This action will update the tag list.' }
                      </p>
                    </>
                  
                  
             
            </div>
          </div>
        </div>
        <div
          className="bg-white px-4 py-3 sm:px-6 sm:flex justify-center sm:flex-row-revers"
          style={{
            boxShadow: "0px -16px 50px 0px #0000000D",
          }}
        >
        
          <button
            type="button"
            className="mt-3 w-full px-8 inline-flex justify-center rounded-md border border-gray-300 shadow-sm  py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm"
            onClick={onClose}
          >
            {action === 'deleteSectorError' || action ==='EditSectorError' ? 'ok' : 'Cancel'}
            
          </button>
          {(action !== 'deleteSectorError' && action !=='EditSectorError') &&
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white sm:ml-3 sm:w-auto sm:text-sm mr-2"
                  onClick={onConfirm}
                >
                  {action ==='delete' ? 'Confirm' :action ==='approve' ? 'Approve': action ==='deleteError' ? 'Yes, Delete': action ==='edit' ? 'Confirm':'Confirm'}
                </button>}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationModal;
